// Copyright (c) Docugami, Inc. All rights reserved.

import { useSelector } from "react-redux";
import { AppState } from "store";
import { useDgAuth } from "./DgAuthentication";
import { useOrganizationFeaturesQuery } from "store/organization/organizationSlice";
import { skipToken } from "@reduxjs/toolkit/dist/query";

export function useOrganizationFeatures() {
    const currentOrgId = useSelector((state: AppState) => state.organizations.currentOrganization?.id);
    const { isAuthenticated } = useDgAuth();

    useOrganizationFeaturesQuery(isAuthenticated && !!currentOrgId ? undefined : skipToken);
}
